<qwiko-auth-nav></qwiko-auth-nav>
<div class="max-h-screen overflow-y-auto pb-24">
  <router-outlet></router-outlet>
</div>

<qwiko-modal
  *transloco="let t; prefix: 'sign_up_page'"
  [id]="'terms-modal'"
  [isCentered]="true"
>
  <div class="flex flex-col items-center h-full pb-20">
    <h2
      *transloco="let t; prefix: 'language_page'"
      class="text-xl font-semibold text-center w-full my-2"
    >
      {{ t("title") }}
    </h2>

    <div class="mt-2 text-right w-full max-w-xs text-sm">
      <p class="text-center text-xs text-gray-500 mb-2">
        {{ t("terms_text_1") }}
        <a
          href="https://nativemind.io/terms-of-service"
          target="_blank"
          rel="noopener noreferrer"
          class="text-gray-500 underline"
          >{{ t("terms_text_2") }}</a
        >
        {{ t("terms_text_3") }}
        <a
          href="https://nativemind.io/privacy-policy"
          target="_blank"
          rel="noopener noreferrer"
          class="text-gray-500 underline"
          >{{ t("terms_text_4") }}</a
        >
        {{ t("terms_text_5") }}
        <a
          href="https://nativemind.io/cookie-policy"
          target="_blank"
          rel="noopener noreferrer"
          class="text-gray-500 underline"
          >{{ t("terms_text_6") }}</a
        >.
      </p>
    </div>
  </div>

  <div
    class="bg-base-300 fixed bottom-0 right-0 left-0 w-100 pt-2 pb-2 px-2 border-t border-t-base-200"
  >
    <div class="flex justify-center items-center w-full px-0 py-0 mx-auto">
      <button
        type="button"
        class="btn btn-md btn-primary rounded-box"
        (click)="closeModal('terms-modal')"
      >
        <span class="flex items-center gap-2">
          <span class="text-base mt-1">{{ t("agree_and_continue") }}</span>
        </span>
      </button>
    </div>
  </div>
</qwiko-modal>
